import React from "react";
import { Box, Typography } from "@mui/material";
import { FilterTypes } from "./filterTypes";

const THEME = {
  jobs: {
    unselectedBg: "#F0F7EE",
    unselectedBorder: "#C8E6C9",
    unselectedText: "#151D48",
    selectedBg: "#64AE68 ",
    selectedBorder: "#64AE68",
    selectedText: "#fff",
  },
  candidates: {
    unselectedBg: "#EBF4FD",
    unselectedBorder: "#BBDEFB",
    unselectedText: "#151D48",
    selectedBg: "#3F95EA",
    selectedBorder: "#3F95EA",
    selectedText: "#fff",
  },
  default: {
    unselectedBg: "#fff",
    unselectedBorder: "rgba(0,108,183,0.20)",
    unselectedText: "#151D48",
    selectedBg: "#3F95EA",
    selectedBorder: "#3F95EA",
    selectedText: "#fff",
  },
};

const TileBox = ({ count, total, label, highlighted, onClick, variant }) => {
  const theme = THEME[variant] || THEME.default;
  return (
    <Box
      onClick={onClick}
      sx={{
        flex: 1,
        p: "10px 15px",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        border: `1px solid ${highlighted ? theme.selectedBorder : theme.unselectedBorder}`,
        backgroundColor: highlighted ? theme.selectedBg : "#fff",
        color: highlighted ? theme.selectedText : theme.unselectedText,
        borderRadius: "10px",
        transition: "all 0.2s ease",
        "&:hover": {
          border: `1px solid ${theme.selectedBorder}`,
          boxShadow: "0 2px 8px rgba(63,149,234,0.15)",
        },
      }}
    >
      <Typography
        sx={{ fontWeight: 700, fontSize: "22px", lineHeight: 1.2, mb: "4px" }}
      >
        {count}
        {total !== undefined && (
          <span
            style={{
              fontSize: "12px",
              marginLeft: "4px",
              fontWeight: 400,
              opacity: 0.75,
            }}
          >
            / {total}
          </span>
        )}
      </Typography>
      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: 500,
          opacity: highlighted ? 1 : 0.7,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

const DashboardTiles = ({
  title,
  tiles = [],
  showFilter = false,
  filterProps = {},
  variant = "default",
  width = "auto",
}) => {
  const theme = THEME[variant] || THEME.default;

  return (
    <Box
      sx={{
        backgroundColor: theme.unselectedBg,
        padding: "10px 14px",
        borderRadius: "10px",
        border: "1px solid #E2E8F0",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        width,
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1.5,
        }}
      >
        <Typography
          sx={{ fontWeight: 700, fontSize: "15px", color: "#151D48" }}
        >
          {title}
        </Typography>
        {showFilter && (
          <FilterTypes
            anchorEl={filterProps.anchorEl}
            open={filterProps.open}
            handleClose={filterProps.handleClose}
            selectedTime={filterProps.selectedTime}
            handleClick={filterProps.handleClick}
            setAnchorElDuration={filterProps.setAnchorElDuration}
          />
        )}
      </Box>

      <Box sx={{ display: "flex", gap: 1.5 }}>
        {tiles.map((tile, i) => (
          <TileBox
            key={i}
            count={tile.count}
            total={tile.total}
            label={tile.label}
            highlighted={tile.isSelected}
            onClick={tile.onClick}
            variant={variant}
          />
        ))}
      </Box>
    </Box>
  );
};

export default DashboardTiles;
